import { Box, Skeleton } from '@mui/material';
import {useTheme} from '@mui/material';

const ProductRowLoader = ({item}) => {
    const theme = useTheme();
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '5px 10px',
                borderRadius: '4px',
            }}
        >
            {/* Skeleton for Product Name */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '30%',
                    gap: '8px',
                }}
            >
                <Skeleton sx={{ bgcolor: 'gray' }} variant="text" width="100%" height={20} />
            </Box>
        
            {/* Skeleton for Buy Price and Button */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30%',
                    gap: '8px',
                }}
            >
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton
                    variant="rectangular"
                    sx={{
                        borderRadius: '50px',
                        width: '80%',
                        height: '30px',
                    }}
                />
            </Box>
        
            {/* Skeleton for Sell Price and Button */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30%',
                    gap: '8px',
                }}
            >
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton
                    variant="rectangular"
                    sx={{
                        borderRadius: '50px',
                        width: '80%',
                        height: '30px',
                    }}
                />
            </Box>
        </Box>
    );
};

export default ProductRowLoader;
